import { useEffect } from "react";
import { brand } from "../config/brand";

export const useBrandTitle = () => {
  useEffect(() => {
    document.title = brand.pageTitle;
  }, []);
};
